import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Box, Button, CircularProgress, Container, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import SendIcon from '@material-ui/icons/Send';
import { attendBreakDown, getUserList } from '../../ReduxStore/Breakdown/BreakdownSlice';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const ApproverList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const asset_id = pathname[3];
    const breakdown_id = pathname[4];
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Breakdown Management', href: '/breakdown-management' },
        { label: 'Current Breakdowns', href: '/breakdown-management/current-breakdowns' },
    ];
    const [postLoading, setPostLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [showUsers, setShowUsers] = useState(false);
    const [departments, setDepartments] = useState({});
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [selectedDeptId, setSelectedDeptId] = useState('');
    const [users, setUsers] = useState([]);
    const [userId, setUserId] = useState([]);

    const [selectedApprover, setSelectedApprover] = useState(null);
    // const [selectedDepartment, setSelectedDepartment] = useState('');

    const handleApproverSelect = (approver) => {
        setSelectedApprover(approver);
        setUserId(approver.id)
    };

    // const handleDepartmentChange = (event) => {
    //     setSelectedDepartment(event.target.value);
    //     setSelectedApprover(null);
    // };

    // const handleSubmit = () => {
    //     if (selectedDepartment && selectedApprover) {
    //         // Fetch existing reports from localStorage
    //         let reports = JSON.parse(localStorage.getItem('report')) || [];

    //         // Find the report by id
    //         const reportIndex = reports.findIndex(report => report.id === asset_id);
    //         if (reportIndex === -1) {
    //             alert("Report not found.");
    //             return;
    //         }

    //         // Get the report details
    //         const reportDetails = reports[reportIndex];

    //         // Remove the report from the report array
    //         reports = reports.filter(report => report.id !== asset_id);

    //         // Save the updated reports back to localStorage
    //         localStorage.setItem('report', JSON.stringify(reports));

    //         const newApprover = {
    //             department: selectedDepartment,
    //             approver: selectedApprover,
    //             report_id: asset_id,
    //             ...reportDetails // Add report details using spread operator
    //         };

    //         // Retrieve existing approvers from localStorage
    //         const existingApprovers = JSON.parse(localStorage.getItem('approve')) || [];

    //         // Add the new approver to the array
    //         const updatedApprovers = [...existingApprovers, newApprover];

    //         // Save the updated approvers back to localStorage
    //         localStorage.setItem('approve', JSON.stringify(updatedApprovers));

    //         console.log("Selected Department:", selectedDepartment);
    //         console.log("Selected Approver:", selectedApprover);
    //         console.log("New Approver Object:", newApprover);

    //         // Navigate to the previous page or any other page if required
    //         navigate('/breakdown-management');
    //     } else {
    //         alert("Please select both department and approver.");
    //     }
    // };
    const handleSubmit = async () => {
        const payload = {
            machine_breakdown_id: breakdown_id,
            status_id: "552a96216ae645afb6e3a5b20ff7e31b", //resolved status id
            customer_id: "af33f9117ecb4d8d8def84d6331eebd4",
            approvers: [{
                approval_user: userId
            }]

        }
        // console.log("payload:", payload)
        try {
            setPostLoading(true)
            const action = dispatch(attendBreakDown(payload));
            const res = await action.unwrap();
            // console.log("res", res.result)
            if (res.StatusCode === 201) {
                toast.success("BreakDown Resolved Successfully!");
                setTimeout(() => {
                    navigate("/breakdown-management");
                }, 2000);
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        } finally {
            setPostLoading(false)
        }
    }

    // const approvers = {
    //     'Maintenance-Approval': ['Vikrant', 'John Doe', 'Jane Smith'],
    //     'CreatorAdmin': ['Alice Brown', 'Bob Green'],
    //     'Administator': ['Charlie Black', 'Dana White']
    // };

    const getUsers = async () => {
        try {
            const action = dispatch(getUserList(asset_id));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                setDepartments(res.result.departments);
                // Convert departments object to an array for easier handling
                const deptArray = Object.values(res.result.departments);
                console.log("check dept,", deptArray)
                setDepartmentOptions(deptArray);
            } else {
                toast.error(res.Message || 'Failed to fetch departments.');
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    };

    useEffect(() => {
        let isMounted = true;  // Track if the component is still mounted

        const fetchData = async () => {
            try {
                await getUsers();
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchData();

        // Cleanup function to prevent state update on unmounted component
        return () => {
            isMounted = false;
        };
    }, []);

    // Handle department selection
    const handleDeptChange = (event) => {
        const deptId = event.target.value;
        setSelectedDeptId(deptId);
        console.log("check")
        if (deptId && departments[deptId]) {
            console.log("check user list:", departments[deptId].users)
            setUsers(departments[deptId].users);
            setShowUsers(true)
        } else {
            console.log("Else run")
            setUsers([]);
        }
    };

    if (loading) {
        return (
          <Layout>
            <Container>
              <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                <GridLoadingSpinner />
              </Box>
            </Container>
          </Layout>
        );
      }

    return (
        <Layout>
            <Container>
                <Box  mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Approver List" />
                </Box>
                <Box mb={2}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={3}>
                            <FormControl variant="filled" fullWidth>
                                <InputLabel>Select Department</InputLabel>
                                <Select
                                    // value={selectedDepartment}
                                    // onChange={handleDepartmentChange}
                                    value={selectedDeptId}
                                    onChange={handleDeptChange}
                                    label="Department"
                                    name="department"
                                >
                                    {departmentOptions.map((dept) => (
                                        <MenuItem key={dept.id} value={dept.id}>
                                            {dept.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
                {selectedDeptId && users.length > 0 ? (
                    <>
                        <Typography variant="h5" gutterBottom>
                            Users in {departments[selectedDeptId].name}
                        </Typography>
                        <Box>
                            <Grid container spacing={2} style={{ maxWidth: '600px', margin: "auto" }}>
                                {users.map((approver, index) => (
                                    <Grid item xs={12} sm={10} key={index}>
                                        <div
                                            className='breakdown-items'
                                            onClick={() => handleApproverSelect(approver)}
                                            style={{
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                backgroundColor: selectedApprover === approver ? '#e0f7fa' : 'transparent',
                                                padding: '10px',
                                                borderRadius: '5px',
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <AccountCircleIcon fontSize='large' />
                                                <p className='text'>{approver.name}</p>
                                            </div>
                                            {selectedApprover === approver && <CheckCircleOutlineIcon fontSize='large' />}
                                        </div>
                                    </Grid>
                                ))}
                                <Grid item xs={12} sm={10}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleSubmit}
                                        endIcon={postLoading ? <CircularProgress size={20} /> : <SendIcon />}
                                        disabled={postLoading}
                                    >
                                        {postLoading ? "Submitting" : "Submit"}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </>
                ) : (
                    <Box mt={4}>
                        <Typography variant="h6">No users found in this department.</Typography>
                    </Box>
                )}
            </Container>
            <ToastContainer />
        </Layout>
    );
}

export default ApproverList;
